var React = require('react');

function MapPin24x24 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Type=Hitta butik, Invert=off, Size=24x24","stroke":"currentColor","strokeWidth":"2"},[React.createElement("path",{"id":"Rectangle 685","d":"M17.739 10.286l-5.74 11.478-5.738-11.478C4.127 6.02 7.23 1 12 1s7.872 5.02 5.739 9.286z","fill":"none","key":0}),React.createElement("circle",{"id":"Ellipse 140","cx":"12","cy":"7","r":"3","key":1})]));
}

MapPin24x24.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = MapPin24x24;

MapPin24x24.default = MapPin24x24;
